<template>
    
            <v-main class="pa-2 report_detail pcksgreport" fluid>

        <v-row>

                <v-col cols="12" md="12" class="inline-form">
                  <v-text-field
                       v-model="filter"
                       prepend-icon="mdi-folder-cog-outline"
                       label="Filter Component Checks"
                       
                     ></v-text-field>
                  <RangePicker @reloadData="loadData" :range="this.getCurrentMonth()"/>
                </v-col>
              </v-row>
                          
              <v-data-table 
                  :search="filter"
                  :headers="headers" 
                  :items="components_logs" item-key="id">
                   <template v-slot:item.checkDate="{ item }">
                      {{new Date(item.checkDate).toLocaleString("en-AU",  { timeZone : "UTC", weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' })}}
                  </template>
                 
              </v-data-table>
              
            </v-main>
    
</template>

<script>
    import { mapState } from 'vuex'
    import RangePicker from '../components/RangePicker.vue'

    export default {

      components : { RangePicker }, 

      // props : { id : {type : String, default : "0" }},
      
        data() {


            return {


              filter : ''
             
             
            }
        },

        mounted () {
          this.$store.dispatch('fetchComponentsLogbyDate', {
                range : this.getDefaultWeek()
            })

        },


        computed: {

          ...mapState(['components_logs']),

          headers() {

           return this.getHeaders(this.components_logs)

          }

        },

        methods: {

          loadData(range) {

              this.$store.dispatch('fetchComponentsLogbyDate', {
                range : range

            })


          },

        
        }
    }
</script>